/*
    Student Unit Test Store module actions

*/

// Import any requires library
import { apolloClient } from '@/setup/apollo-setup';
import {LEGACY_UNSAVED_LEARN_TIME_KEY, signedInStudentCode, unsavedLearnTimeKey} from "@/utils/unsaved-learn-time";

// Import any utility
import { error, /* newItemSuccess, */ /* updateItemSuccess, */ /* deleteItemSuccess */ } from '@/utils/notification';

// Import defined GraphQL Query or Mutation

import {
  ADD_STUDENT_UNIT_TOPIC_LEARN,
  UPDATE_STUDENT_LEARN_TIME,
  ADD_STUDENT_UNIT_AND_TOPIC_LEARN,
  UPDATE_STUDENT_TOPIC_AND_UNIT_LEARN,
  UPDATE_UNSAVED_STUDENT_TOPIC_AND_UNIT_LEARN,
  UPDATE_REVIEW_SOCRE,
} from '@/queries/modules/student-unit-learn';

export async function addStudentTopicLearn(context, payload) {

  const { commit } = context;

  commit('clearError');
  commit('setProcessing', true);

  try {
      const response = await apolloClient
      .mutate({
        mutation: ADD_STUDENT_UNIT_TOPIC_LEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })

      const {data} = response;

      context.commit('setSuccess', null);

      return  data.addStudentTopicLearn

  } catch (e) {

    // console.log(e);

    commit('setError', error(e));
    return null;

  }
}

export async function addStudentUnitLearnAndTopic(context, payload) {
  const { commit } = context;

  commit('clearError');
  commit('setProcessing', true);
  try {
      const response = await apolloClient
      .mutate({
        mutation: ADD_STUDENT_UNIT_AND_TOPIC_LEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })

      const { data } = response;

      context.commit('setSuccess', null);

      return data.addStudentUnitLearnAndTopic;

  } catch (e) {
    commit('setError', error(e));
    return null;
  }
}

export async function updateStudentTopicLearnTime(context, payload) {
  const { commit } = context;
  commit('clearError');
  commit('setProcessing', true);
  try {
      const response = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENT_LEARN_TIME,
        variables: payload,
        fetchPolicy: "no-cache",
        context: { clientName: 'Prisma2' }
      })

      const {data} = response;

      context.commit('setSuccess', null);

      return data.updateProfile

  } catch (e) {

    // console.log(e);

    commit('setError', error(e));
    return null;

  }
}

export async function updateStudentTopicAndUnitLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENT_TOPIC_AND_UNIT_LEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      return data.updateStudentTopicAndUnitLearn
    }

  } catch (e) {
    console.error('[updateStudentTopicAndUnitLearn] Error:', e); // eslint-disable-line no-console
    if (e.networkError) {
      console.error('[updateStudentTopicAndUnitLearn] Network error status:', e.networkError.statusCode || e.networkError.status); // eslint-disable-line no-console
    }
    context.commit('setError', error(e));
    return null;
  }
}

export async function checkUnsavedLearnTime(context) {
  // Written before entries were bound to a student, so its owner is unknown;
  // replaying it could credit whoever signed in last. Dropped unreplayed.
  localStorage.removeItem(LEGACY_UNSAVED_LEARN_TIME_KEY);
  const localStorageKey = unsavedLearnTimeKey(signedInStudentCode());
  if (!localStorageKey) {
    return;
  }
  let unSavedItems = localStorage.getItem(localStorageKey);
  if (unSavedItems) {
    unSavedItems = JSON.parse(unSavedItems);
    let savedKey = [];
    for (let key of Object.keys(unSavedItems)) {
      let payload = unSavedItems[key];
      let result = await context.dispatch('updateUnsavedStudentTopicAndUnitLearn', payload)

      if (result) {
        savedKey.push(key);
        delete unSavedItems[key];
      }
    }

    //remove saved items from unsaved items
    for (let key of savedKey) {
      delete unSavedItems[key];
    }

    //clear or set new unsaved items
    if (Object.keys(unSavedItems).length === 0) {
      localStorage.removeItem(localStorageKey);
    } else {
      localStorage.setItem(localStorageKey, JSON.stringify(unSavedItems));
    }

  }
}

export async function updateUnsavedStudentTopicAndUnitLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_UNSAVED_STUDENT_TOPIC_AND_UNIT_LEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      return data.updateUnsavedStudentTopicAndUnitLearn
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateReviewScore(payload) {
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_REVIEW_SOCRE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      return null;
    } else {

      return data.updateReviewScore
    }

  } catch (e) {
    return null;
  }
}

